<script setup lang="ts">
import { PhList, PhX } from '@phosphor-icons/vue'
import { DialogContent, DialogPortal, DialogRoot, DialogTrigger, DialogTitle, VisuallyHidden } from 'reka-ui'

import { useMediaQuery } from '../utils/use-media-query'
import { Button } from '../button'
import { Accordion } from '../accordion'

defineProps<{
  ariaLabel?: string
}>()

const isDesktop = useMediaQuery('md')
</script>

<template>
  <div class="flex items-center w-full gap-2">
    <!-- Desktop Menu -->
    <div v-if="isDesktop"
         class="hidden md:flex">
      <slot />
    </div>
    <div class="flex-1" />
    <!-- Mobile Menu -->
    <DialogRoot v-if="!isDesktop"
                :modal="false">
      <DialogTrigger class="group"
                     as-child>
        <Button type="icon-only"
                class="flex md:hidden"
                :aria-label="ariaLabel">
          <PhList weight="bold"
                  class="w-6 h-6 block group-data-[state=open]:hidden" />
          <PhX weight="bold"
               class="w-6 h-6 hidden group-data-[state=open]:block" />
        </Button>
      </DialogTrigger>
      <DialogPortal>
        <DialogContent class="block z-40 md:hidden bg-background fixed top-0 left-0 w-full h-dvh animate-in slide-in-from-top duration-300 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:slide-out-to-top data-[state=open]:slide-in-from-top data-[state=closed]:duration-300 data-[state=open]:duration-300">
          <!-- Dialog title is needed for screenreader access -->
          <VisuallyHidden as-child>
            <DialogTitle>Seitennavigation</DialogTitle>
          </VisuallyHidden>
          <div class="h-[72px]" />
          <div class="flex flex-col gap-2 py-6">
            <Accordion>
              <slot />
            </Accordion>
          </div>
        </DialogContent>
      </DialogPortal>
    </DialogRoot>
  </div>
</template>
